export const SNS_LINK = '/schedule-and-save/about.html';

export enum DeliveryInstructionType {
  UNATTENDED = 'UNATTENDED',
  ATTENDED = 'ATTENDED',
}

export enum DriverTipType {
  NOTIP = 'noTip',
  PREFERENCES_OTHER = 'other',
}

export const paymentConfig = {
  paymentContext: 'SCHEDULE_SAVE',
  client: 'ScheduleSave',
  paymentEdit: 'edit',
};

export const dvid = 'GhXAoLXN-ss-search';

export const otaModalConfigId: string = 'snsOneTimeAddModal';

export const otaManualBootstrapConfiguration = {
  manualComponentId: 'snsOneTimeAdd',
};
